package com.evoapps.evoshift.data.dto.finance

import kotlinx.serialization.Serializable


@Serializable
data class CostDto(
    val id: String,
    val name: String,
    val amount: Double,
    val currency: String,
    val date: String,
    val sourceType: CostSourceTypeDto,
    val originRuleId: String? = null,
    /** A one-off expense's note (SH-84). */
    val note: String? = null,
    /** SH-87: "COST" or "REVENUE"; documents from before SH-87 have none (a cost). */
    val kind: String = "COST",
    /** SH-131: the shared cost an ALLOCATED_FROM_OWNER part belongs to, and how it was split. */
    val originSharedCostId: String? = null,
    val allocationMethod: String? = null,
    val allocationBasis: String? = null,
    /** This part's share of the shared cost's month total, in percent. */
    val allocationShare: Double? = null,
    /** The shared cost's month total. */
    val sharedTotal: Double? = null,
    /** A one-off item covering several days: its last day (inclusive); none is the single day [date]. */
    val endDate: String? = null,
    /** SH-195: the frequency of the rule (or shared cost) the item was materialised from: MONTHLY, YEARLY, WEEKLY, ONE_OFF. */
    val frequency: String? = null
)

@Serializable
enum class CostSourceTypeDto {
    GENERATED_FROM_RULE,
    MANUAL_ONE_OFF,
    /** SH-131: a workplace's part of an owner's shared cost (functions/sharedCosts.js). */
    ALLOCATED_FROM_OWNER
}
